import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store";
import App from "./App";
import { NavigationProvider } from "./context/navigation";

// Load Dynatrace script dynamically
const dynatracePath = import.meta.env.VITE_DYNATRACE_PATH;
if (dynatracePath) {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = `https://js-cdn.dynatrace.com/jstag/${dynatracePath}`;
  script.crossOrigin = "anonymous";
  document.head.appendChild(script);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Provider store={store}>
      <NavigationProvider>
        <App />
      </NavigationProvider>
    </Provider>
  </>,
);